import { render, staticRenderFns } from "./ProductInstruction.vue?vue&type=template&id=1e804c01&"
import script from "./ProductInstruction.vue?vue&type=script&lang=js&"
export * from "./ProductInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports